module.exports = __webpack_public_path__ + "static/Lato-Thin-9a77fbaa85fa42b73e3b96399daf49c5.ttf";